export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DURATION = 180;

export const UTC = "UTC";
export const Local = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const FIVE_SECONDS = 5000;
